import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LiquidityAccount } from "../../create-loan/liquidity-calculator/types";

export interface LiquidityStore {
  accounts: LiquidityAccount[];
  loading: boolean;
  error: string | null;
}

export const liquidityInitialState: LiquidityStore = {
  accounts: [],
  loading: false,
  error: null
};

const liquiditySlice = createSlice({
  name: "liquidity",
  initialState: liquidityInitialState,
  reducers: {
    setLiquidityLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setLiquidityError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setLiquidityAccounts: (state, action: PayloadAction<LiquidityAccount[]>) => {
      state.accounts = action.payload;
    },
    addLiquidityAccount: (state, action: PayloadAction<LiquidityAccount>) => {
      state.accounts.push(action.payload);
    },
    updateLiquidityAccountInStore: (
      state,
      action: PayloadAction<LiquidityAccount>
    ) => {
      const index = state.accounts.findIndex(
        (account) => account.id === action.payload.id
      );
      if (index !== -1) {
        state.accounts[index] = action.payload;
      }
    },
    removeLiquidityAccount: (state, action: PayloadAction<string>) => {
      state.accounts = state.accounts.filter(
        (account) => account.id !== action.payload
      );
    }
  }
});

export const {
  setLiquidityLoading,
  setLiquidityError,
  setLiquidityAccounts,
  addLiquidityAccount,
  updateLiquidityAccountInStore,
  removeLiquidityAccount
} = liquiditySlice.actions;

export const LiquidityAccountsReducer = liquiditySlice.reducer;
